import {
  cart,
  favourite,
  notification,
  order,
  profile,
  setting,
  activeCart,
  activeFavourite,
  activeNotification,
  activeOrder,
  activeProfile,
  activeSetting,
  review,
  activeReview,
} from '../../assets/svgs';
import styles from './style.module.css';
import { NavLink, useLocation } from 'react-router-dom';

export const SidebarProfile = () => {

  const location = useLocation()

  const items = [
    { label: 'Profile', href: '/buyer-profile', icon: profile, activeIcon: activeProfile, extraActive: [] },
    { label: 'Notifications', href: '/buyer-notification', icon: notification, activeIcon: activeNotification, extraActive: [] },
    { label: 'Cart', href: '/buyer-cart', icon: cart, activeIcon: activeCart, extraActive: ['/buyer-checkout'] },
    { label: 'My Orders', href: '/buyer-orders', icon: order, activeIcon: activeOrder, extraActive: ['/buyer-order'] },
    { label: 'Favourite', href: '/buyer-favourite', icon: favourite, activeIcon: activeFavourite, extraActive: [] },
    { label: 'Review', href: '/buyer-review', icon: review, activeIcon: activeReview, extraActive: ['/buyer-rate'] },
    { label: 'Settings', href: '/buyer-settings', icon: setting, activeIcon: activeSetting, extraActive: [] },
  ];

  return (
    <aside className={styles.sidebar}>
      <nav className={styles.sidebarNav}>
        
        {items.map((item) => {
          const isActive =
            location.pathname === item.href ||
            item.extraActive.some((path) => location.pathname.startsWith(path));

          return (
            <NavLink key={item.href} to={item.href} className={styles.sidebarLink}>
              <>
                <img src={isActive ? item.activeIcon : item.icon} alt={item.label} />
                <span className={`${styles.sidebarText} ${isActive ? styles.sidebarTextActive : ''}`}>
                  {item.label}
                </span>
              </>
            </NavLink>
          );
        })}

      </nav>
    </aside>
  );
};
